import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createInjectorsEnhancer } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';

import createReducer from 'app/redux/reducers';

const reduxSagaMonitorOptions = {};
const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
const { run: runSaga } = sagaMiddleware;
const middlewares = [sagaMiddleware];

const enhancers = [
  createInjectorsEnhancer({
    createReducer,
    runSaga,
  }),
];

export const store = configureStore({
  reducer: createReducer(),
  middleware: [...getDefaultMiddleware(), ...middlewares],
  devTools: process.env.NODE_ENV !== 'production',
  enhancers,
});

// if (module.hot) {
//   module.hot.accept('./reducers', () => {
//     forceReducerReload(store);
//   });
// }

export type RootState = ReturnType<typeof store.getState>;
